import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { ProductTypes, } from '@as-react/common-types';
import { useEffect, useCallback, useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { ProductGroup } from '../../components/product-group/ProductGroup';
import { FASCIA_AND_MAIN_WEB_SHOP } from '../../constants/GeneralConstants';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { ProductAddToBasketLocations } from '../../enums/ActionEnums';
import { useProductTileHelpers } from '../../hooks/useProductTileHelpers';
import { ProductRecentlyViewedActions } from '../../redux/productRecentlyViewed/actions/ProductRecentlyViewedActions.creators';
import { maketGetProductRecentlyViewedState } from '../../redux/productRecentlyViewed/selectors/ProductRecentlyViewedSelectors';
import { makeGetWishListProducts, makeGetWishlistTotalPages } from '../../redux/wishList/selectors/WishListSelectors';
import { MiniPDPContainer } from '../MiniPDPContainer';
const ProductRecentlyViewedContainer = ({ tileFormat, deliveryPromiseExplanations, collapsed, collapsible, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const dispatch = useDispatch();
    const { pageInfo, mainWebShop } = useAemConfig();
    const { isWishlistPage } = pageInfo;
    const productRecentlyViewed = useSelector(maketGetProductRecentlyViewedState());
    const wishlistItems = useSelector(makeGetWishListProducts());
    const wishlistTotalPages = useSelector(makeGetWishlistTotalPages());
    const { handleWishlistToggle, handleUpdateCompareList, handleAddToBasket, compareItems } = useProductTileHelpers();
    useEffect(() => {
        dispatch(ProductRecentlyViewedActions.getRecentlyViewedProducts());
    }, []);
    const recentlyViewedProducts = useMemo(() => isWishlistPage
        ? productRecentlyViewed.filter(product => !wishlistItems.find(wishlistItem => wishlistItem.productId === product.productId))
        : productRecentlyViewed, [isWishlistPage, wishlistItems, productRecentlyViewed]);
    const getDeliveryPromise = useCallback((payload) => dispatch(ProductRecentlyViewedActions.getDeliveryPromise(payload)), []);
    const [miniPDPProduct, setMiniPDPProduct] = useState(null);
    const handleMiniPDPClose = () => {
        setMiniPDPProduct(null);
    };
    if (recentlyViewedProducts.length === 0 && !miniPDPProduct) {
        return null;
    }
    if (isWishlistPage && wishlistTotalPages > 1) {
        return null;
    }
    const handleTileClick = (e, product, color) => {
        const isNotBever = mainWebShop !== FASCIA_AND_MAIN_WEB_SHOP['1_BEVER'];
        const isPhysicalVoucher = [
            ProductTypes.PAPER_VOUCHER,
            ProductTypes.CUSTOM_PAPER_VOUCHER,
            ProductTypes.GIFT_CARD,
            ProductTypes.CUSTOM_GIFT_CARD,
        ].includes(product.type);
        const isEVoucher = product.type === ProductTypes.E_VOUCHER;
        if (isEVoucher || (isPhysicalVoucher && isNotBever)) {
            return;
        }
        e.preventDefault();
        e.stopPropagation();
        setMiniPDPProduct(Object.assign(Object.assign({}, product), { colourId: color.colourId }));
    };
    return (_jsxs(_Fragment, { children: [_jsx(ProductGroup, { products: recentlyViewedProducts, onWishListToggle: handleWishlistToggle, updateCompareList: handleUpdateCompareList, productTileFormat: tileFormat, addToBasket: (...args) => handleAddToBasket(...args, ProductAddToBasketLocations.RECENTLY_VIEWED), getDeliveryPromise: getDeliveryPromise, deliveryPromiseExplanations: deliveryPromiseExplanations, collapsed: collapsed, collapsible: collapsible, compareItems: compareItems, onTileClick: isWishlistPage ? handleTileClick : undefined, productGroupId: "product-recently-viewed", analyticsAreaName: "recently-viewed", title: t('pdp.recently-viewed.title'), analyticsProductGroupName: "recently_viewed" }), isWishlistPage && (_jsx(MiniPDPContainer, { productCode: miniPDPProduct === null || miniPDPProduct === void 0 ? void 0 : miniPDPProduct.productCode, colorId: miniPDPProduct === null || miniPDPProduct === void 0 ? void 0 : miniPDPProduct.colourId, onClose: handleMiniPDPClose, deliveryPromiseExplanations: deliveryPromiseExplanations }))] }));
};
export default ProductRecentlyViewedContainer;
